import { baseResources, baseResourceActions } from "routes/enum";

const {
    AGENTS_INBOX_SERVICE_SETTING,
    AGENTS_INBOX_PERSONA,
    AGENTS_INBOX_CONVERSATION_BREAKER,
    AGENTS_INBOX_CONVERSATION_BREAKER_OPTION,
    AGENTS_INBOX_REMINDER,
} = baseResources;

const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View service module */
export const SERVICE_MODULE_READ_PERMISSION = [
    `${READ}_${AGENTS_INBOX_SERVICE_SETTING}`,
];

/** Edit service module settings */
export const SERVICE_MODULE_UPDATE_PERMISSION = [
    `${UPDATE}_${AGENTS_INBOX_SERVICE_SETTING}`,
];

/** Add new persona */
export const PERSONA_CREATE_PERMISSION = [`${CREATE}_${AGENTS_INBOX_PERSONA}`];

/** Edit persona */
export const PERSONA_UPDATE_PERMISSION = [`${UPDATE}_${AGENTS_INBOX_PERSONA}`];

/** Delete persona */
export const PERSONA_DELETE_PERMISSION = [`${DELETE}_${AGENTS_INBOX_PERSONA}`];

/** Edit conversation breakers */
export const CONVERSATION_BREAKER_UPDATE_PERMISSION = [
    `${UPDATE}_${AGENTS_INBOX_CONVERSATION_BREAKER}`,
];

/** Add options to conversation breakers */
export const CONVERSATION_BREAKER_OPTION_CREATE_PERMISSION = [
    `${CREATE}_${AGENTS_INBOX_CONVERSATION_BREAKER_OPTION}`,
];

/** Create reminder */
export const REMINDER_CREATE_PERMISSION = [`${CREATE}_${AGENTS_INBOX_REMINDER}`];

/** Edit reminder */
export const REMINDER_UPDATE_PERMISSION = [`${UPDATE}_${AGENTS_INBOX_REMINDER}`];

/** Delete reminder */
export const REMINDER_DELETE_PERMISSION = [`${DELETE}_${AGENTS_INBOX_REMINDER}`];

export const PERSONA_WRITE_PERMISSION = [
    ...PERSONA_CREATE_PERMISSION,
    ...PERSONA_UPDATE_PERMISSION,
];

export const SERVICE_MODULE_PERMISSION_MAP = {
    "View service module": SERVICE_MODULE_READ_PERMISSION,
    "Edit service module (team name, subtitle, number of chats, default template, default theme, chat theme color, chat URL, initial branch)":
        SERVICE_MODULE_UPDATE_PERMISSION,
    "Add new persona": PERSONA_CREATE_PERMISSION,
    "Edit persona": PERSONA_UPDATE_PERMISSION,
    "Delete persona": PERSONA_DELETE_PERMISSION,
    "Edit conversation breakers": CONVERSATION_BREAKER_UPDATE_PERMISSION,
    "Add options to conversation breakers":
        CONVERSATION_BREAKER_OPTION_CREATE_PERMISSION,
    "Create reminder": REMINDER_CREATE_PERMISSION,
    "Edit reminder": REMINDER_UPDATE_PERMISSION,
    "Delete reminder": REMINDER_DELETE_PERMISSION,
};
